module.exports = __webpack_public_path__ + "static/media/blog-ads-vs-reco-thumb@2x.79c202c2.jpg";